import React from 'react';
import { ContentBranch, HeroBlockProps, YoutubeBlockProps } from '@customTypes/storyblok-types';
import { DisclosureWrapper } from '@components/disclosure/DisclosureWrapper';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { useTranslate } from '@tolgee/react';
import { MetaBlock } from '../MetaBlok';
import { ISbRichtext, storyblokEditable } from '@storyblok/react';
import { FAQSection } from './FaqSection';

export interface FAQContent {
  body: Array<{
    title: string;
    section: ContentBranch | 'sprenger';
    entries: Array<{
      entries: Array<{
        text: ISbRichtext;
        title: string;
        seo_answer: string;
        youtube: YoutubeBlockProps[];
      }>;
      title: string;
    }>;
  }>;
  header: Array<HeroBlockProps>;
}

export const FaqPage: React.FC<{ content: any }> = ({ content }) => {
  const { t } = useTranslate();

  return (
    <div
      className="w-full"
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      /* @ts-ignore*/
      {...storyblokEditable(content)}
    >
      <MetaBlock
        content={content}
        defaults={{
          description: 'seo.description.faq',
          meta_keywords: 'seo.meta_keywords.faq',
          title: 'seo.title.faq',
        }}
      />
      <header className="w-full box-x-wrapper">
        <Breadcrumbs className="mt-4 mb-11" />
      </header>

      <main className="relative w-full box-x-wrapper flex flex-col md:grid md:grid-cols-3 grid-cols-1 gap-5">
        <h1 className="col-span-3 order-1 text-h-40 md:text-h-72 md:mb-8">FAQ</h1>
        <div className="md:col-span-2 order-3 md:order-2">
          {content.body.map((section: ArrayElementOf<FAQContent['body']>) => (
            <FAQSection key={section.title} section={section} />
          ))}
        </div>
        <div className="pr-wrapper order-2 md:order-3">
          <DisclosureWrapper
            className="md:sticky mb-8 md:mb-0 md:top-48 lg:top-36 md:right-[5%] "
            content={content.body.map((section: ArrayElementOf<FAQContent['body']>) => ({
              headline: section.title,
              sublines: section.entries.map((e) => ({
                href: `${section.title + e.title}`,
                title: e.title,
              })),
            }))}
            headline={t('faq.disclosure.headline')}
          />
        </div>
      </main>
    </div>
  );
};
